import React, { useContext, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  FormControlLabel,
  Switch,
} from "@material-ui/core";
import clsx from "clsx";
import { AppContext } from "../AppContextProvider";
import { LeadService } from "../Services/LeadService";

const useStyles = makeStyles((theme) => ({
  root: {},
}));

export default function ClosureSettings(props) {
  const classes = useStyles();
  const {
    setTitle,
    showSnackBar,
    closeProgressDialog,
    showProgressDialog,
  } = useContext(AppContext);
  const [blockFlowOnHoldings, setBlockFlowOnHoldings] = useState(false);

  useEffect(() => {
    setTitle("Account Closure Settings");
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchData = () => {
    showProgressDialog();
    LeadService.getClosureConfig()
      .then((data) => {
        if (data.success) {
          setBlockFlowOnHoldings(!!data.config.block_flow_on_holdings);
        }
        closeProgressDialog();
      })
      .catch((error) => {
        console.log(error);
        closeProgressDialog();
        showSnackBar("Something went wrong while fetching. Please try again.", "error");
      });
  };

  const handleChange = (e) => {
    const checked = e.target.checked;
    showProgressDialog("Updating Setting...");
    LeadService.updateClosureConfig({ block_flow_on_holdings: checked })
      .then((data) => {
        if (data.success) {
          showSnackBar("Setting updated", "info");
          setBlockFlowOnHoldings(checked);
        } else {
          showSnackBar(data.error || "Failed to update setting.", "error");
        }
        closeProgressDialog();
      })
      .catch((error) => {
        console.log(error);
        showSnackBar("Failed to update setting. Please try again.", "error");
        closeProgressDialog();
      });
  };

  return (
    <div className="Home">
      <div className="lander">
        <div>
          <Grid container direction="row" spacing={4} justify="center">
            <Grid item xl={10} lg={10} xs={12}>
              <Card className={clsx(classes.root)}>
                <CardContent>
                  <Grid
                    container
                    justify="space-between"
                    alignItems="center"
                    spacing={1}
                  >
                    <Grid item xs={12} sm={8} md={8} lg={8} style={{ padding: 12 }}>
                      <Typography variant="body1" align="left">
                        Block the closure flow when the client has holdings
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={4} md={4} lg={4} style={{ padding: 12 }}>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={blockFlowOnHoldings}
                            onChange={handleChange}
                            name="block_flow_on_holdings"
                            color="primary"
                          />
                        }
                        label= {blockFlowOnHoldings ? "Enabled" : "Disabled"}
                      />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  );
}
